import { useTranslation } from 'next-i18next';

import { FramePicker } from '../../../components/Containers/ReviewCheckoutDrawer/FramePicker';
import { useFlow } from '../../../providers';
import { usePurchase } from '../../../providers/PurchaseProvider';
import { CurrencyCode } from '../../../types/Locations';

interface Props {
  product: ProductType;
  currencyCode?: CurrencyCode;
  frameByDefault?: boolean;
}

export const FrameStep = ({ currencyCode, frameByDefault, product }: Props) => {
  const { goToStep } = useFlow();
  const purchasingController = usePurchase();
  const { t } = useTranslation(['product']);

  if (!purchasingController.frameOptions) {
    return null;
  }

  const productSubtotal = purchasingController.collectionSet
    ? purchasingController.collectionSet.reduce(
        (acc, item) => acc + item.price * item.quantity,
        0,
      )
    : (purchasingController.product?.price ?? 0) *
      purchasingController.quantity;

  return (
    <FramePicker
      currencyCode={currencyCode}
      description={
        product.details.length ? product.details[0].framingOptions : ''
      }
      frameByDefault={frameByDefault}
      frameOptions={purchasingController.frameOptions}
      frameSelected={purchasingController.frame}
      hideSubmitButton={false}
      hideTitle
      includeUnframed
      onGetInTouchClick={() => {
        window.open('/support/contact ', '_blank', 'noopener,noreferrer');
      }}
      onSubmit={(frame) => {
        purchasingController.setFrame(frame);
        goToStep('apply');
      }}
      productSubtotal={productSubtotal}
      submitButtonLabel={t('drawers.review.framing.cta')}
    />
  );
};
